var _style, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtherDocument(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.3 26.5",
    style: {
      enableBackground: "new 0 0 23.3 26.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{fill:none;stroke:#909090;stroke-width:1.5135;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#909090;stroke-width:1.42;stroke-linecap:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 23.3,
    height: 26.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.3,22.5V2.4c0-0.9,0.8-1.7,1.7-1.7h11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.5,6.7V24c0,0.9-0.9,1.7-1.8,1.7h-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.8,9.4h9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.8,12.7h9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.8,16h9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,6.8l5.5,0.1c0.1,0,0.1-0.1,0.1-0.2L17,0.8c-0.1-0.1-0.2,0-0.2,0.1v5.8C16.8,6.7,16.8,6.8,16.9,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.3,25.7c-0.3,0-1.4,0-2.3-0.8c-1.1-0.9-1.2-2.2-1.2-2.5h0.1H15c0,0.2,0.1,1.5,1.2,2.5c1,0.8,2,0.8,2.3,0.8 H4.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherDocument);
export default __webpack_public_path__ + "static/media/other_document.e3ea78566d887b6b5d7e702a7dfb88ab.svg";
export { ForwardRef as ReactComponent };